import { render, staticRenderFns } from "./sxetika-me-tin-etairia.vue?vue&type=template&id=78084e78"
import script from "./sxetika-me-tin-etairia.vue?vue&type=script&lang=js"
export * from "./sxetika-me-tin-etairia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductBanner: require('/opt/build/repo/components/product/Banner.vue').default,SectionBrandsCarousel: require('/opt/build/repo/components/section/BrandsCarousel.vue').default})
